import { StaffSchedule } from "../interfaces"
import { DayKey } from "./mskCalendar"

// Локальные алиасы — чтобы компонентам не писать StaffSchedule.ScheduleMap каждый раз.
export type CellKey = StaffSchedule.CellKey
export type ScheduleMap = StaffSchedule.ScheduleMap

/**
 * Единственный источник формата ключа ячейки. Им пользуются и кэш (store), и грид.
 * Ключ уникален: у сотрудника не может быть двух смен на одну дату (upsert на бэкенде).
 */
export const cellKey = (staffId: number, dayKey: DayKey): CellKey =>
  `${staffId}:${dayKey}`

/** Колонка «Всего дней» по сотруднику. */
export const totalsByStaff = (cells: ScheduleMap): Map<number, number> => {
  const map = new Map<number, number>()
  for (const s of Object.values(cells)) {
    map.set(s.staff_id, (map.get(s.staff_id) ?? 0) + 1)
  }
  return map
}

/** Строка «Итог» — сколько человек в смене на конкретную дату. */
export const totalsByDay = (cells: ScheduleMap): Map<DayKey, number> => {
  const map = new Map<DayKey, number>()
  for (const key of Object.keys(cells)) {
    const dayKey = key.split(":")[1]
    map.set(dayKey, (map.get(dayKey) ?? 0) + 1)
  }
  return map
}

export const grandTotal = (cells: ScheduleMap): number =>
  Object.keys(cells).length

/** Счётчики по типам смен — для палитры. */
export const countsByShiftType = (cells: ScheduleMap): Map<number, number> => {
  const map = new Map<number, number>()
  for (const s of Object.values(cells)) {
    map.set(s.shift_type_id, (map.get(s.shift_type_id) ?? 0) + 1)
  }
  return map
}
